import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";

/* Convert data entered in HTML editor into HTML tag format. */
export const convertHtmlEditorStateToHtmlTag = (editorState: any) => {
  return draftToHtml(convertToRaw(editorState.getCurrentContent()));
};
